export default __webpack_public_path__ + "static/lets@3x-437ce5ba8c9e44a015851b3c363cd6a9.png";